var _path;
import { jsx as _jsx } from "react/jsx-runtime";
var Upload = function Upload(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? 'tw-text-neutral-light-800' : _ref$className,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size;
  return /*#__PURE__*/_jsx("svg", {
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    children: _path || (_path = /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M11 21a1 1 0 1 0 2 0v-9.586l3.293 3.293a1 1 0 0 0 1.414-1.414l-5-5-.006-.007A.997.997 0 0 0 12.003 8h-.006a.997.997 0 0 0-.705.294l-5 4.999a1 1 0 1 0 1.415 1.414L11 11.414V21Zm9-12a1 1 0 0 1-1-1V6a1 1 0 0 0-1-1H6a1 1 0 0 0-1 1v2a1 1 0 1 1-2 0V6a3 3 0 0 1 3-3h12a3 3 0 0 1 3 3v2a1 1 0 0 1-1 1Z",
      fill: "none",
      className: "tw-fill-current"
    }))
  });
};
export default Upload;